//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/Section.js";
import "../Features/Features.SheetMetal.HoleTreatmentBuilder.js";
import "../Features/Features.SheetMetal.CornerTreatmentBuilder.js";
import "../no/SelectFace.js";
import "../no/SelectEdge.js";
import "../no/Features.js";
import "../no/ugmath.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[1,"AddedGeometry",0,"Section",0],[0,"Associative",1,0],[0,"BendDirectionDownText",1,0],[0,"BendDirectionUpText",1,0],[0,"FixAtTimestamp",1,0],[0,"FlatPatternViewName",0,0],[1,"HoleTreatment",0,"Features.SheetMetal.HoleTreatmentBuilder",0],[1,"InnerCornerTreatment",0,"Features.SheetMetal.CornerTreatmentBuilder",0],[0,"KeepFlatSolidExternal",1,0],[0,"Orientation",1,0],[0,"OrientationCsys",1,"CoordinateSystem",0],[1,"OuterCornerTreatment",0,"Features.SheetMetal.CornerTreatmentBuilder",0],[0,"ReferenceVertex",1,0],[0,"ShowInteriorFeatureCurves",1,0],[0,"TransformToAbsoluteCsys",1,0],[1,"UpwardFace",0,"SelectFace",0],[1,"XAxisEdge",0,"SelectEdge",0]],[[[],"GenerateMoldLines",{},0,0],[["face"],"IsValidFaceForFlatPattern",{R_:{isValidFace:''}},1,0]],[]];
SPLM.Features.SheetMetal.FlatPatternBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.FlatPatternBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;